// extracted by mini-css-extract-plugin
export default {"arcard":"styles_arcard__67Hl3"};